// extracted by mini-css-extract-plugin
module.exports = {"AccentTitle":"AccentTitle_AccentTitle__KO8hJ","Number":"AccentTitle_Number__2pVCp","Title":"AccentTitle_Title__2zywd","Text":"AccentTitle_Text__2HOBD"};